module.exports = __webpack_public_path__ + "static/media/ic_day_check_purple.ce6439c0.svg";